export const Texts = {
  /** @NEW_CONSTANTS */
  errors: {
    noItemFound: "NO ITEM FOUND",
    alertFail: "정보를 가져오는 데 실패했습니다!",
    alertFailUpdate: "정보를 수정하는 데 실패했습니다!",
    invalidPosName: "INVALID POSNAME",
    notSupportedYet: "Not supported yet",
    itemNotFound: "해당 메뉴가 존재하지 않습니다.",
    itemDeleteFailure: "메뉴 삭제에 실패 했습니다. 잠시후 다시 시도해주세요.",
  },
  shopMenu: {
    failItems: '메뉴를 불러오는데 실패 했습니다.',
    failShopInfo: '매장 정보를 불러오는데 실패 했습니다.',
    failOption: '옵션 정보를 불러오는데 실패 했습니다.',
    posBtnTitle: 'POS메뉴 불러오기',
    posBtnReset: "메뉴 초기화",

    haveItem: '',
    haveNoItem: 'SOLD OUT',

    itemDeleteSuccess: '메뉴를 삭제 했습니다.',
    itemDelteFailure: '메뉴 삭제에 실패 했습니다. 잠시후 다시 시도해주세요.',
    delete: '삭제',
    modify: '수정',
    modifyTitle: '메뉴 수정',
    menuTitle: '메뉴명',
  },

  menuItem: {
    soldout: 'SOLD OUT',
    best: '대표메뉴',
    new: '신메뉴',
    hot: '인기메뉴',
    hidden: '숨겨진 메뉴입니다.'
  },



  /** @NEW_CONSTANTS */

  alertMessages: {
    SUCCESS: "성공적으로 처리되었습니다.",
    FAIL: "처리에 실패했습니다. 잠시후 다시 시도해주세요.",
    NO_ITEM_FOUND: "항목이 존재하지 않습니다!",
    NOT_SUPPORTED_YET: "아직 지원하지 않습니다!",
    INVALID_PARAM: "유효하지 않은 파라미터입니다!",

    FAIL_GET: "정보를 가져오는 데 실패했습니다! 잠시후 다시 시도해주세요.",
    FAIL_UPDATE: "정보를 수정하는 데 실패했습니다! 잠시후 다시 시도해주세요.",
    FAIL_DELETE: "항목 삭제에 실패했습니다! 잠시후 다시 시도해주세요.",
  },

  shopMenus: {
    // Menu Item
    MENU_ITEM_LIST: "메뉴 아이템 목록",
    MENU_ITEM: "메뉴 아이템",
    MENU_GROUP_LIST: "메뉴 그룹 목록",
    MENU_GROUP: "메뉴 그룹",

    MENU_OPTION: "메뉴 옵션",
    MENU_OPTION_GROUP: "옵션 그룹",
    MENU_OPTION_CLASS: "옵션 클래스",
    MENU_OPTION_LIST: "메뉴 옵션 목록",
    MENU_OPTION_ITEM_LIST: "옵션 아이템 목록",
    MENU_OPTION_ITEM: "옵션 아이템",

    SOLDOUT: "SOLD OUT",
    BEST: "대표메뉴",
    NEW: "신메뉴",
    HOT: "인기메뉴",
    HIDDEN: "숨겨진 메뉴입니다.",
  },

  btnTitles: {
    POS_MENU_UPDATE: "POS메뉴 불러오기",
    DEL: "삭제",
    MODIFY: "수정",
  },


}